import Router from "./router"
import { AppProvider } from "./context/AppContext"

function App() {
  return (
    <AppProvider>
      <Router />
    </AppProvider>
  )
}

export default App
